






import { AuthService } from "@/services/auth.service";
import { AuthModule } from "@/store/auth.module";
import { ReportsModule } from "@/store/reports.module";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class GetDoc extends Vue {
  async created() {
    //console.log("created");
    //alert('created');

    const { guid } = this.$route.params;
    if (!guid) {
      return this.$router.replace("/auth");
    }
  }

  async mounted() {
    //console.log("mounted");
    //alert('mounted');
    const { guid } = this.$route.params;
    const r = await ReportsModule.getDoc(guid);

    const byteOffset = 0;
    const b = new Blob(
      [new Uint8Array((r as any).result.data, byteOffset, length)],
      { type: "application/pdf" },
    );

    const fileURL = URL.createObjectURL(b);
    window.open(fileURL, "_self");

    this.$router.push("/auth");
  }
}
